<template>
  <layouts>
    <template #content>
      <zloading v-if="loading"></zloading>
      <div v-else class="bg-gray-200 h-auto">
        <div class="container px-4 py-10 mx-auto max-w-7xl">
          <div class="flex items-start justify-between">
            <div>
              <h1 class="text-xl text-gray-800 font-medium mb-1">
                Ringkasan Pengguna Baru
              </h1>
              <h4 class="text-sm text-gray-500">
                Periode
                {{ stringDate(start_date) + " - " + stringDate(end_date) }}
              </h4>
            </div>
            <div class="flex items-center">
              <zdropdown :text="filterDate">
                <template v-slot:item>
                  <div class="py-6 px-6">
                    <h4 class="text-sm font-medium mr-2 mb-1">
                      Rentang Tanggal:
                    </h4>
                    <zselect
                      class="mb-5"
                      v-model="filterDate"
                      :data="[
                        'Hari Ini',
                        'Bulan Ini',
                        'Tahun Ini',
                        '7 Hari Terakhir',
                        '30 Hari Terakhir',
                      ]"
                      placeholder="Pilih Periode"
                      @input="selectRangeDate"
                    >
                    </zselect>
                    <h1 class="font-medium mb-5 text-base">atau</h1>
                    <div class="flex items-center space-x-2">
                      <div class="w-1/2">
                        <h4 class="text-sm font-medium mr-2 mb-1">
                          Tanggal Mulai:
                        </h4>
                        <input
                          @input="refreshData"
                          v-model="start_date"
                          class="w-full mr-5 rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                          type="date"
                        />
                      </div>
                      <div class="w-1/2">
                        <h4 class="text-sm font-medium mr-2 mb-1">
                          Tanggal Akhir:
                        </h4>
                        <input
                          @input="refreshData"
                          v-model="end_date"
                          class="w-full rounded-md border-2 border-gray-300 focus:outline-none focus:border-blue-800 text-sm px-3 py-1.5"
                          type="date"
                        />
                      </div>
                    </div>
                    <!-- <div class="flex items-center">
                                            <button class="mt-5 bg-blue-600 hover:bg-blue-700 px-4 py-2 text-semibold text-white rounded-md shadow">Terapkan</button>
                                        </div> -->
                  </div>
                </template>
              </zdropdown>
            </div>
          </div>
          <div class="flex item-center space-x-4 mt-10">
            <div class="w-1/3 bg-white shadow rounded-md px-6 py-4 text-center">
              <h4 class="text-base font-medium mb-2">Total Agen</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_agen }}
              </h1>
            </div>
            <div class="w-1/3 bg-white shadow rounded-md px-6 py-4 text-center">
              <h4 class="text-base font-medium mb-2">Total Member</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_member }}
              </h1>
            </div>
            <div class="w-1/3 bg-white shadow rounded-md px-6 py-4 text-center">
              <h4 class="text-base font-medium mb-2">Total Akun Pengguna</h4>
              <h1 class="text-xl font-semibold text-blue-800">
                {{ total_user }}
              </h1>
            </div>
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Agen Baru
            </h1>
            <line-chart
              v-if="agen_loaded"
              :chartdata="agen_statistics"
              :options="options"
            />
            <div id="chart-bar" class="flex-auto"></div>
          </div>
          <div class="mt-5 bg-white shadow rounded-md px-6 py-6">
            <h1 class="text-base text-gray-800 font-semibold mb-5">
              Statistik Member Baru
            </h1>
            <line-chart
              v-if="member_loaded"
              :chartdata="member_statistics"
              :options="options"
            />
            <div id="chart-bar" class="flex-auto"></div>
          </div>
        </div>
      </div>
    </template>
  </layouts>
</template>

<script>
import layouts from "@/components/layouts";
import zdropdown from "@/components/zdropdown";
import zselect from "@/components/zselect";
import zloading from "@/components/zloading";
import LineChart from "@/components/zlinechart";
import { reactive, computed } from "@vue/composition-api";
import {
  useReportAgen,
  useReportMember,
  useReportUser,
  useReportAgenStatistics,
  useReportMemberStatistics,
} from "@/composables/report/useReport";

export default {
  components: { layouts, zdropdown, zselect, LineChart, zloading },
  setup() {
    const reportParams = reactive({ start_date: "", end_date: "" });
    const params = computed(() => ({ ...reportParams }));
    const agenQuery = useReportAgen(params);
    const memberQuery = useReportMember(params);
    const userQuery = useReportUser(params);
    const agenStatQuery = useReportAgenStatistics(params);
    const memberStatQuery = useReportMemberStatistics(params);
    return {
      reportParams,
      rqAgenData: agenQuery.data,
      rqAgenIsLoading: agenQuery.isLoading,
      rqMemberData: memberQuery.data,
      rqUserData: userQuery.data,
      rqAgenStatData: agenStatQuery.data,
      rqMemberStatData: memberStatQuery.data,
    };
  },
  data() {
    return {
      /* Filter */
      filterDate: "Bulan Ini",
      /* Chart Data */
      options: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    start_date: {
      get() {
        return this.reportParams.start_date;
      },
      set(v) {
        this.reportParams.start_date = v;
      },
    },
    end_date: {
      get() {
        return this.reportParams.end_date;
      },
      set(v) {
        this.reportParams.end_date = v;
      },
    },
    total_agen() {
      const raw = this.rqAgenData;
      const arr = raw && raw.data ? raw.data : [];
      return arr.length === 0 ? 0 : arr[0].count;
    },
    total_member() {
      const raw = this.rqMemberData;
      const arr = raw && raw.data ? raw.data : [];
      return arr.length === 0 ? 0 : arr[0].count;
    },
    total_user() {
      const raw = this.rqUserData;
      const arr = raw && raw.data ? raw.data : [];
      return arr.length === 0 ? 0 : arr[0].count;
    },
    agen_statistics() {
      const raw = this.rqAgenStatData;
      const arr = raw && raw.data ? raw.data : null;
      if (!arr) return null;
      return {
        labels: arr.map((item) => item.date),
        datasets: [
          {
            label: "Total Agen",
            borderColor: "rgba(50, 115, 220, 0.5)",
            backgroundColor: "rgba(50, 115, 220, 0.1)",
            data: arr.map((item) => item.order_count),
          },
        ],
      };
    },
    member_statistics() {
      const raw = this.rqMemberStatData;
      const arr = raw && raw.data ? raw.data : null;
      if (!arr) return null;
      return {
        labels: arr.map((item) => item.date),
        datasets: [
          {
            label: "Total Member",
            borderColor: "rgba(255, 56, 96, 0.5)",
            backgroundColor: "rgba(255, 56, 96, 0.1)",
            data: arr.map((item) => item.order_count),
          },
        ],
      };
    },
    agen_loaded() {
      return !!this.agen_statistics;
    },
    member_loaded() {
      return !!this.member_statistics;
    },
    loading() {
      return this.rqAgenIsLoading && !this.rqAgenData;
    },
  },
  created() {
    this.selectRangeDate();
  },
  methods: {
    /* Helpers */
    refreshData() {
      /* useQuery auto-refetch when reportParams change */
    },
    selectRangeDate() {
      let date = new Date();
      let firstDay;
      let lastDay;

      switch (this.filterDate) {
        case "Hari Ini":
          firstDay = date;
          lastDay = date;
          break;

        case "Bulan Ini":
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;

        case "Tahun Ini":
          firstDay = new Date(date.getFullYear(), 0, 1);
          lastDay = new Date(date.getFullYear(), 11, 31);
          break;

        case "7 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 7));
          lastDay = new Date();
          break;

        case "30 Hari Terakhir":
          firstDay = new Date(date.setDate(date.getDate() - 30));
          lastDay = new Date();
          break;

        default:
          firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          break;
      }

      this.start_date = this.formatDate(firstDay);
      this.end_date = this.formatDate(lastDay);

      /* Refresh Data */
      this.refreshData();
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    stringDate(value) {
      let options = { year: "numeric", month: "long", day: "numeric" };
      let date = new Date(value).toLocaleString("id-ID", options);
      return date;
    },
    formatPrice(number) {
      var rupiah = "";
      var angkarev = number
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
  },
};
</script>

<style scoped></style>
